module.exports = __webpack_public_path__ + "img/home-1-891x535.d16c4182.png";